import React from "react";
import { Form, Row, Col, Select, Divider } from "antd";
import MoneyInput from "./MoneyInput";
import { optionsMonth } from "../../../../utils/constant/MonthSelect";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { CalendarOutlined } from "@ant-design/icons";

const FormPaymentSection = ({
  form,
  radioDecide,
  radioFinish,
  onChangeDateAgreement,
  onChangePaydue,
}) => {
  const showInstallment = radioDecide === "agreement";

  return (
    <>
      <Divider orientation="left">🤝 ทำยอม</Divider>
      <Form.Item
        label="ยินยอมชำระเงินจำนวน"
        name="paymentDue"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 14 }}
        rules={[{ required: true, message: "กรุณาใส่เงินต้นที่ทำยอม" }]}
      >
        <MoneyInput placeholder="กรุณาใส่จำนวนเงิน" onChange={onChangePaydue} />
      </Form.Item>

      {showInstallment && (
        <Row gutter={16} align="middle" style={{ marginBottom: "20px" }}>
          <Col span={12}>
            <Form.Item
              label="งวดละไม่น้อยกว่า"
              name="paymentPerMonthAmount"
              style={{ marginBottom: 20 }}
              labelCol={{ span: 12 }}
              rules={[
                { required: true, message: "กรุณาใส่เงินที่ต้องชำระรายเดือน" },
              ]}
            >
              <MoneyInput placeholder="กรุณาใส่จำนวนเงิน" />
            </Form.Item>
            <Form.Item
              label="วันนัดชำระครั้งแรก"
              name="dueDate"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
              rules={[{ required: true, message: "โปรดเลือกวันที่นัดชำระ" }]}
            >
              <ThaiDatePicker
                placeholder="กรุณาเลือกวันที่"
                size="large"
                style={{ width: "100%" }}
                suffixIcon={<CalendarOutlined />}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="จำนวนกี่เดือน"
              name="costMonth3"
              style={{ marginBottom: 60 }}
              labelCol={{ span: 6 }}
              rules={[{ required: true, message: "กรุณาใส่จำนวนงวด" }]}
            >
              <Select
                showSearch
                size="large"
                style={{ width: "100%" }}
                popupMatchSelectWidth={false}
                optionFilterProp="label"
                options={optionsMonth}
                placeholder="เลือกจำนวนเดือน"
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </>
  );
};

export default FormPaymentSection;
